import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.125 16.21V8.252h2.959A2.25 2.25 0 0 0 10.334 6l-.002-2.957h3.793a.75.75 0 0 1 .75.75V16.21a.75.75 0 0 1-.75.75h-8.25a.75.75 0 0 1-.75-.75m1.06-9.458 2.647-2.65.002 1.9a.75.75 0 0 1-.75.75zm-2.56 1.371c0-.596.237-1.169.658-1.59l4.327-4.33c.422-.422.995-.66 1.592-.66h3.923a2.25 2.25 0 0 1 2.25 2.25V16.21a2.25 2.25 0 0 1-2.25 2.25h-8.25a2.25 2.25 0 0 1-2.25-2.25zm8.875 3.212a.75.75 0 1 1 0 1.5h-5a.75.75 0 0 1 0-1.5zm-2.5 2.5a.75.75 0 1 1 0 1.5H7.5a.75.75 0 0 1 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }